import React from 'react';


const Footer = () => {
    return (
        <div className="container mt-3 bg-light">
              <div class="d-flex flex-column">
        <footer class="footer">
          <div className="text-center">
            <a href="https://www.themoviedb.org/">TMDB</a>
            <span>&copy; 2020 MovieBank.</span>
          </div>
          <div className="text-center">
            <span>Powered by</span>
            <a href="https://www.themoviedb.org/">TMBD</a>
          </div>
        </footer>
      </div>

        </div>
      
    );
};

export default Footer;